import Pages from "../layouts/Pages.jsx";
import LoginLayout from '../layouts/LoginLayout'
//import RTL from "layouts/RTL.jsx";
import TemplateDashboard from "../layouts/TemplateDashboard";
import BurnerDashboard from "../layouts/MainDashboard";
import * as types from "src/types";
var indexRoutes = [
 /* { path: "/rtl", name: "RTL", component: RTL },*/
  { path: "/pages", name: "Pages", component: Pages },
  { path: "/template", name: "Home", component: TemplateDashboard },
  { path: "/views", name: "Home", component: BurnerDashboard },
  { redirect: true, path: "/", pathTo: "/views/podcast", name: "Home" ,component: BurnerDashboard }
];
//@ts-ignore
export function getRoutes(connect:types.IState):Array<any>{
    let indexRouters = []
    indexRouters.push({ path: "/template", name: "Home", component: TemplateDashboard })
    indexRouters.push(  { path: "/pages", name: "Pages", component: LoginLayout });
    indexRouters.push(  { path: "/views", name: "Home", component: BurnerDashboard } );
      indexRouters.push(  {redirect: true, path: "/", pathTo: "/views/discovery", name: "Home", component: LoginLayout } );
     // indexRouters.push({ redirect: true, path: "/views", pathTo: "/views/tracks/new", name: "Home" ,component: BurnerDashboard } )
    //}
    //else if( connect.lo_ctx.error()){
     // indexRouters.push(  { redirect: true, path: "/views", pathTo: "/pages/login", name: "Home", component: LoginLayout } );
      //indexRouters.push(  { redirect: true, path: "/", pathTo: "/pages/login", name: "Home", component: LoginLayout } );
    //}
    
    //indexRouters.push(  { path: "/views/tracks/new/start", name: "Home", component: BurnerDashboard } );
    return indexRouters;
}
export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.tsx